import { flushOnHide } from './queue'

let installed = false

export function installProductAnalytics(): () => void {
  if (typeof window === 'undefined' || installed) return () => undefined
  installed = true
  const onVisibility = () => {
    if (document.visibilityState === 'hidden') flushOnHide()
  }
  window.addEventListener('pagehide', flushOnHide)
  document.addEventListener('visibilitychange', onVisibility)
  return () => {
    installed = false
    window.removeEventListener('pagehide', flushOnHide)
    document.removeEventListener('visibilitychange', onVisibility)
  }
}
